import type { ApiResponse } from "../shared/responses"
import type { CitiesResponse, City, PrefectureId } from "./types"
import { API } from "../shared/api"

export const fetchCities = async (
    prefectureId: PrefectureId
): Promise<ApiResponse<City[]>> => {
    try {
        const response = await fetch(
            `${API.ENDPOINTS.CITIES}?prefecture_id=${prefectureId}`,
            {
                headers: {
                    "Content-Type": API.HEADERS.CONTENT_TYPE,
                },
            }
        )

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        const json: CitiesResponse = await response.json()

        if (json.status === "success") {
            return {
                success: true,
                data: json.data,
                error: null,
            }
        }

        return {
            success: false,
            data: [],
            error: json.message || "Failed to fetch cities",
        }
    } catch (error) {
        return {
            success: false,
            data: [],
            error:
                error instanceof Error
                    ? error.message
                    : "Unknown error occurred",
        }
    }
}
